var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurveillance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M.8 8C.8 6.5 2 5.2 3.6 5.2h10c1.5 0 2.8 1.2 2.8 2.8v8c0 1.5-1.2 2.8-2.8 2.8h-10C2.1 18.8.8 17.6.8 16V8zm2.7-1.2c-.7 0-1.3.5-1.3 1.2v8c0 .7.6 1.2 1.2 1.2h10c.7 0 1.2-.6 1.2-1.2V8c0-.7-.6-1.2-1.2-1.2H3.5z",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M22.4 6.4c.2.1.3.4.3.6v10c0 .2-.1.5-.3.6-.2.1-.5.2-.7.1l-6.5-2.5c-.3-.1-.5-.4-.5-.7v-5c0-.3.2-.6.5-.7l6.5-2.5c.3-.1.5-.1.7.1zM16.2 10v4l5 1.9V8.1l-5 1.9z",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveillance);
export default __webpack_public_path__ + "static/media/Surveillance.3ce384607d80428952d1189719726947.svg";
export { ForwardRef as ReactComponent };